import type { AxiosError } from 'axios'
import { format } from 'date-fns'
import { useMutation, useQuery } from '@tanstack/react-query'
import apiClient from '../Utils/apiClient'
import { returnArray } from '../Utils/reactQueryUtils'
import type { ExportOption, ExportRequest } from '../dtos'
import type { ExportGroup, Product } from '../enums'

const baseUrl = import.meta.env.VITE_BASE_URL
const apiUrl = import.meta.env.VITE_EXPORT_API
const url = `${baseUrl}/${apiUrl}`

export const useGetExportOptions = (product?: Product, group?: ExportGroup) => {
  return useQuery({
    queryKey: ['GetExportOptions', product, group],
    queryFn: () => apiClient.get<ExportOption[]>(`${url}/GetExportOptions`, { params: { product, group } }).then(returnArray)
  })
}

export const useGetExportUrl = (request: ExportRequest) => {
  const params = new URLSearchParams()
  if (request.product)
    params.append('Product', request.product.toString())
  if (request.exportType)
    params.append('ExportType', request.exportType.toString())
  if (request.dateType)
    params.append('DateType', request.dateType.toString())
  if (request.fileFormat)
    params.append('fileformat', request.fileFormat.toString())
  if (request.email)
    params.append('Email', request.email)
  if (request.dateFrom)
    params.append('DateFrom', format(new Date(request.dateFrom), 'yyyy-MM-dd'))
  if (request.dateTo)
    params.append('DateTo', format(new Date(request.dateTo), 'yyyy-MM-dd'))

  return `${url}/GetExport?${params.toString()}`
}

export const useSendExportEmail = (request: ExportRequest) => {
  const url = useGetExportUrl(request)

  return useMutation<string, AxiosError>({
    mutationFn: () => apiClient.get(url).then(res => res.data)
  })
}